/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export { BigBoardService } from './services/big-board.service';
export { CompetitionService } from './services/competition.service';
export { ConferenceService } from './services/conference.service';
export { MenuService } from './services/menu.service';
export { MetadataService } from './services/metadata.service';
export { PlayerService } from './services/player.service';
export { PlayerNotesService } from './services/player-notes.service';
export { RateService } from './services/rate.service';
export { TeamService } from './services/team.service';
export { UserService } from './services/user.service';
export { WatchlistService } from './services/watchlist.service';
